import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Collaborator } from './types'

export const COLLABORATORS_QUERY: TypedDocumentNode<
  { collaborators: Collaborator[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Collaborators($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    collaborators(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name role email info collaborators_functions image image_low_res observations sort_order pastor_order pastor_rank created_at updated_at
    }
  }
`

export const COLLABORATOR_QUERY: TypedDocumentNode<
  { collaborator: Collaborator | null },
  { id: string }
> = gql`
  query Collaborator($id: ID!) {
    collaborator(id: $id) {
      id client_id application_id name role email info collaborators_functions image image_low_res observations sort_order pastor_order pastor_rank created_at updated_at
    }
  }
`
